import clsx from "clsx"
import React, { ReactElement, ReactNode, useState } from "react"
import { useAppSelector } from "../../../lib/redux/hook.ts"
import { colors } from "../../colors.ts"
import { Radio } from "../../molecules/radio/index.tsx"
import { SpinnerComponent } from "../../molecules/spinner/index.tsx"
interface Props {
    name: string,
    price: string,
    onChange?: (value: boolean) => void,
    onClick?: () => void,
    checked: boolean
    limitInfo?: string
    infoProduct: ReactNode
    isLoading: boolean
}
export function SubscriptionChoiceCard(props: Props) {
    const { name, price, onChange, checked, limitInfo, infoProduct, isLoading } = props

    const layoutState = useAppSelector(state => state.layout)
    const [hover, setHover] = useState(false)

    const match = limitInfo ? limitInfo.match(/€\s?\d{1,3}(?:\.\d{3})*,\d{2}/) : ''

    let beforePart: ReactElement;
    let afterPart: ReactElement;

    if (match) {
        const price = match[0];
        const [before, after] = limitInfo ? limitInfo.split(price) : ['', '']

        beforePart = (
            <span className="font-medium text-text-xs lg:text-text-md text-neutral-500">
                {before}
                <strong className="font-bold">{price}</strong>
                {after.slice(0, after.indexOf("anziché"))}
            </span>
        );

        afterPart = (
            <span className="font-medium text-text-xs lg:text-text-md text-neutral-500">
                {after.slice(after.indexOf("anziché"))}
            </span>
        );
    } else {
        beforePart = (
            <span className="font-medium text-text-xs lg:text-text-md text-neutral-500">
                {limitInfo}
            </span>
        );
        afterPart = <div></div>
    }

    return (
        <div onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} onClick={() => props.onClick && props.onClick()}
            style={{ borderColor: name === "Free" ? colors.green[500] : name === "Unlimited" ? layoutState.theme[300] : layoutState.theme[200], backgroundColor: checked || hover ? layoutState.theme[50] : colors.white }}
            className={
                clsx(' cursor-pointer shadow-xs flex flex-col rounded-xl border w-full')}
        >
            <div className=" flex flex-col items-start justify-start w-full p-4 gap-2 flex-grow">
                <div className=" flex flex-row items-center justify-between w-full ">
                    <div className='font-bold text-text-md lg:text-text-lg text-brandSecondary-800'>{name}</div>
                    {
                        !isLoading &&
                        <Radio
                            hover={hover}
                            onChange={(value) => onChange && onChange(value)}
                            isChecked={checked}
                            value={name}
                            size='sm'
                            radioGroup='subscription'
                        />
                    }
                </div>
                <div className='flex flex-row justify-center items-center gap-2'>
                    <span className='font-semibold text-heading-lg lg:text-heading-xl text-brandSecondary-800'>
                        {isLoading ? <SpinnerComponent size={20} /> : price}
                    </span>
                    <span className='font-medium text-text-sm lg:text-text-md text-neutral-500'>€/mese</span>
                </div>
                {limitInfo?.includes('anzi') ?
                    <div className='flex flex-col justify-start gap-2'>
                        {beforePart}
                        {afterPart}
                    </div> :
                    <div className='flex flex-row justify-center items-center gap-2'>
                        <span className='font-medium text-text-xs lg:text-text-md text-neutral-500'>{limitInfo}</span>
                    </div>
                }
            </div>
            <div className='flex flex-col gap-1 px-4 pb-6 justify-center flex-grow'>
                {infoProduct}
            </div>
        </div>
    )
}